<template>
	<div class="My_pop _popRight _popdetails" id="POP-CAdetails-2"  style="display: block;" ><!-- POP -->
		<div class="pop_right " style="right: 0px;" v-loading="loadingMask"><!-- pop_right -->
			<ul class="pop_right_header2">
				<li><h2>详情</h2></li>
				<li><btn class="pop_right_close2" name="pop-details-close" @click="closeFloat"></btn></li>
			</ul>
			<div class="pop_right_main"><!-- main -->
			
	
						<ul class="form_list">
							<li>
								<h4>反馈类型</h4>
								<div class="">
									<ul class="mul-choice-list single" >
										<li @click="fankuiform.type='功能异常'" :style="{'pointer-events':isedit==0?'none':''}"><check class="cei-icon" v-bind:class="fankuiform.type=='功能异常'?'s-checked':'s-checkbox'"></check>功能异常</li>
										<li @click="fankuiform.type='产品建议'" :style="{'pointer-events':isedit==0?'none':''}"><check class="cei-icon" v-bind:class="fankuiform.type=='产品建议'?'s-checked':'s-checkbox'"></check>产品建议</li>
										<li @click="fankuiform.type='其他'" :style="{'pointer-events':isedit==0?'none':''}"><check class="cei-icon" v-bind:class="fankuiform.type=='其他'?'s-checked':'s-checkbox'"></check>其他</li>
									</ul>
								</div>
							</li>
							<li>
								<h4>反馈内容</h4>
								<div style="border: 1px solid #d9d9d9;">
									<div class="">
										<textarea class="s_textarea" placeholder="请详细描述您的问题，我们将竭力为您服务！" rows="10" maxlength="300" style="resize: none;border: none !important;" v-model="fankuiform.desc" :readonly="!isedit"></textarea>
										<span class="grey1" style="float: right;margin-right: 20px;">{{fankuiform.desc.length}}/300</span>
									</div>
									<div class="s_insert_pic" style="margin-top: 16px;border: none !important;">
										<div class="s_insert_pic-L" v-show="isedit" ><btn class="insertpic" title="插入选择图片" :style="{'pointer-events':isedit==0?'none':''}" ><pic><input type="file" id="file" accept="image/*" v-on:change="uploadFile" style="opacity: 0;width: 100%;height: 100%;cursor: pointer;"  /></pic></btn></div>
										<div class="s_insert_pic-R" >
											<div v-for="(item,index) in fankuiatts" class="pic"><img v-bind:src="item.image"    alt=""/><i class="cei-icon icon-del" @click="delFile(item.attId)" :style="{'pointer-events':isedit==0?'none':''}" v-show="isedit"></i></div>
										</div>
									</div>
								</div>
								<span class="grey1" style="float: right;margin-right: 20px;">单张图片最大可上传大小为1MB</span>
							</li>
							<li>
								<h4>联系方式</h4>
								<div class=""><input type="text" class="s_input" placeholder="联系电话/邮箱地址"  v-model="fankuiform.phone"  :readonly="!isedit" ></div>
							</li>
						</ul>
	
				
			</div><!-- /main -->
			
			<div class="pop_right_footer2">
				<btn class="s_btn" v-if="!isedit"  @click="isedit=1" >修改</btn>
				<btn class="s_btn" v-else @click="updatefankui"  >保存</btn>
			</div>
			
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;"  @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask:true,
				isedit:0,
				fankuiDetail:'',
				fankuiform: {
					desc: '',
					type:'',
					phone:''
				},
				fankuiatts:[],
			}
		},
		props:[
			'detailid'
		],
		mounted: function() {
			this.getFankuiDetailfnc();
			this.$track([
				['pagetype','查看建议反馈']
			]);
		},
		methods: {
			getFankuiDetailfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserFeedback',
						responseType: 'json',
						params: {
							id: this.detailid,
						},
					})
					.then(function(response) {
						_this.fankuiDetail = response.data.data.data.feedback;
						var fankuiContent= JSON.parse(_this.fankuiDetail.content);
						_this.fankuiform.desc=fankuiContent.desc;
						_this.fankuiform.type=fankuiContent.type;
						_this.fankuiform.phone=fankuiContent.phone;
						var tempatts=response.data.data.data.att;
						var tempimages=response.data.data.data.images;
						for(var i=0;i<tempatts.length;i++){
							_this.fankuiatts.push({
								attId:tempatts[i].id,
								fileName:tempatts[i].filename,
								image:tempimages[tempatts[i].id]
							})
						}
						_this.$track([
							['pagetype','查看建议反馈详情']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			updatefankui:function(){
				if(!this.fankuiform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.fankuiform.type){
					this.$message({
						message: '请选择类型',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.fankuiform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if((!regmobile.test(this.fankuiform.phone))&&(!regtel.test(this.fankuiform.phone))&&(!regemail.test(this.fankuiform.phone))){
						this.$message({
							message: '请填写正确的联系方式,如邮箱、手机号、固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempfankui={
					type:this.fankuiform.type,
					desc:this.fankuiform.desc,
					phone:this.fankuiform.phone
				}
				var tempAttidArr=[];
				var tempAttnameArr=[];
				for(var i=0;i<this.fankuiatts.length;i++){
					tempAttidArr.push(this.fankuiatts[i].attId);
					tempAttnameArr.push(this.fankuiatts[i].fileName);
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/UpdateUserFeedback',
						responseType: 'json',
						params: {
							id:this.detailid,
							content: JSON.stringify(tempfankui),
							atts:tempAttidArr.length>0?tempAttidArr.join(','):'',
							filenames:tempAttnameArr.length>0?tempAttnameArr.join(','):'',
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '建议反馈修改成功',
								type: 'success'
							});
							_this.fankuiform.desc='';
							// _this.fankuiform.type='';
							_this.fankuiform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','修改建议反馈']
							]);
						}
						else{
							_this.$message({
								message: '建议反馈修改失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '建议反馈修改失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			uploadFile:function(event){
				if(event.target.files.length>0){
					var upfile=event.target.files[0];
					var formdata=new FormData();
					formdata.append('file',upfile);
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/UploadFile',
							data: formdata,
							headers: {
							  'Content-Type': 'multipart/form-data'
							}
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.fankuiatts.push(response.data.data.data);
								_this.$message({
									message: '上传成功',
									type: 'success'
								});
							}
							else{
								_this.$message({
									message: '上传失败:'+response.data.data.msg,
									type: 'error'
								});
							}
			
						})
						.catch(function(error) {
							_this.$message({
								message: '上传错误:'+response.data.data.msg,
								type: 'error'
							});
							// _this.closeFloat();
							console.log(error);
						});
				}
				
			},
			delFile:function(id){
				for(var i=0;i<this.fankuiatts.length;i++){
					if(this.fankuiatts[i].attId==id){
						this.fankuiatts.splice(i,1);
						break;
					}
				}
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			
		},
	}
</script>

<style>
</style>
